import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00B8AD",
      "fill-rule": "evenodd",
      d: "M11.5 6.04a5 5 0 1 1-10 0 5 5 0 0 1 10 0m1 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0M6.854 3.02 9.52 5.686l.354.354-.354.354L6.854 9.06l-.708-.707L7.96 6.54H3.167v-1H7.96L6.146 3.727z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }